import { filledDollarCount, MAX_DOLLARS } from '../dollars'

export type DollarRatingProps = {
  /**
   * Ribbon `efficiencyIndex` on a 1–5 scale (higher = more cost-efficient /
   * cheaper). Rendered inverted so it reads like a price: `efficiencyIndex` is
   * higher = better value (cheaper), but `$$$$$` universally means expensive —
   * so the most efficient provider shows the *fewest* `$`.
   */
  efficiencyIndex: number
  className?: string
}

export const DollarRating = ({ efficiencyIndex, className }: DollarRatingProps) => {
  // Inverted so the cheapest provider shows the fewest $ — see app/dollars.ts, which
  // the provider social card shares so the two can't disagree.
  const filledCount = filledDollarCount(efficiencyIndex)

  return (
    <div
      className={['inline-flex items-center gap-0.5', className].filter(Boolean).join(' ')}
      role="img"
      aria-label={`${filledCount} out of ${MAX_DOLLARS} dollar signs`}
      data-testid="dollar-rating"
    >
      {Array.from({ length: MAX_DOLLARS }, (_, index) => {
        const filled = index < filledCount
        return (
          <span
            // biome-ignore lint/suspicious/noArrayIndexKey: dollar glyphs are identical static icons
            key={index}
            className={filled ? 'text-secondary-800' : 'text-secondary-300'}
            data-testid={filled ? 'dollar-rating-filled' : 'dollar-rating-muted'}
            aria-hidden="true"
          >
            $
          </span>
        )
      })}
    </div>
  )
}
